import { Buffer as BufferPolyfill } from 'buffer';

export const cloneDeep = (entity, cache = new WeakMap()) => {
  const referenceTypes = ['Array', 'Object', 'Map', 'Set', 'Date'];
  const entityType = Object.prototype.toString.call(entity);
  if (BufferPolyfill.isBuffer(entity)) {
    return entity;
  }
  if (!new RegExp(referenceTypes.join('|')).test(entityType) || entity instanceof WeakMap || entity instanceof WeakSet || entity instanceof Uint8Array || entity?.type === 'Buffer') return entity;
  if (cache.has(entity)) {
    return cache.get(entity);
  }
  if (entity && typeof entity === 'object' && (typeof entity.pipe === 'function' || typeof entity._read === 'function' || typeof entity._write === 'function')) {
    return entity;
  }
  const c = new entity.constructor();

  if (entity instanceof Map) {
    entity.forEach((value, key) => c.set(cloneDeep(key), cloneDeep(value)));
  }
  if (entity instanceof Set) {
    entity.forEach((value) => c.add(cloneDeep(value)));
  }
  if (entity instanceof Date) {
    return new Date(entity);
  }
  cache.set(entity, c);
  return Object.assign(c, ...Object.keys(entity).map((prop) => ({ [prop]: cloneDeep(entity[prop], cache) })));
};
